import actions from './user/actions';
import mutations from './user/mutations';
import getters from './user/getters';

// User Login State
const state = {
  jwtToken: localStorage.getItem('cc-jwt'),
  consultWebSocket: {
    ws: null,
    room: '',
  },
  exclusiveWebSocket: {
    ws: null,
    room: '',
  },
  userLogin: {
    isLogin: false,
    djangoId: null,
    hashCode: '',
    profile: {},
  },
  liffVendor: '',
  subscribe: [],
  shopCart: [],
  shopCartFlow: 0,
  shopPurchaseType: '',
  scoreTicker: 1,
  scoreStatus: {},
  topBarStatus: {
    isSearchBarFocus: false,
    isNotifyFocus: false,
    isUserPanelFocus: false,
    isHamburgerFocus: false,
    isUserFeatureFocus: false,
    isSearchBarMobileActive: false,
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
  strict: true,
};
